import { icons } from '../../../../shared/icons';
import MuiGrid from '../../UI/MuiGrid/MuiGrid';

const OpcijeProgramaGridProvider = ({
  data,
  loading,
  handleRowClick,
  handleOpenDelete,
}) => {
  const opcijeColumns = [
    {
      field: 'id',
      headerName: 'Id',
      width: 90,
    },
    {
      field: 'naziv',
      headerName: 'Naziv opcije',
      width: 300,
    },
    {
      field: 'ikonica',
      headerName: 'Ikonica',
      width: 200,
    },
    {
      field: 'cvor',
      headerName: 'Čvor',
      width: 150,
      type: 'boolean',
    },
    {
      field: 'podcvor',
      headerName: 'Podčvor',
      width: 150,
      type: 'boolean',
    },
    {
      field: 'dokument',
      headerName: 'Dokument',
      width: 150,
      type: 'boolean',
    },
    {
      field: 'opcije',
      disableExport: true,
      headerName: 'Opcije',
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenDelete(e.id)}
        >
          {icons.DELETE_ICON}
        </span>
      ),
    },
  ];

  return (
    <div style={{ height: '80vh', width: '80vw', marginTop: '10px' }}>
      <MuiGrid
        data={data}
        loading={loading}
        columns={opcijeColumns}
        onRowDoubleClick={(e) => handleRowClick(e)}
      />
    </div>
  );
};

export default OpcijeProgramaGridProvider;
